import moment from "moment";

import { Enums } from "../../thor.enums";
import { EnumHelpers } from "../../utils/enum-helpers";

export class SelectLangController {
    public static $inject: string[] = [
        "$mdDateLocale",
        "$state",
        "$translate",
        "categoryService",
        "utilsService"
    ];

    // Binded
    public currentLang: Enums.Locale;

    public langLabel = Enums.LangLabel;
    public langList = <Enums.Locale[]>EnumHelpers.getValues(Enums.Locale);

    constructor(
        public $mdDateLocale: ng.material.IDateLocaleProvider,
        public $state: ng.ui.IStateService,
        private $translate: ng.translate.ITranslateService,
        public categoryService,
        private utils
    ) {}

    public $onInit() {
        this.currentLang = this.utils.getCurrentLang();
        this.setLocaleDate();
    }

    public changeLang(langKey: Enums.Locale): void {
        this.currentLang = langKey || this.currentLang;
        this.$translate.use(this.currentLang);
        this.categoryService.translate();
        this.$state.reload();
    }

    private setLocaleDate() {
        moment.locale(this.currentLang);

        // Datepicker labels
        this.$mdDateLocale.months = moment.months();
        this.$mdDateLocale.shortMonths = moment.monthsShort();
        this.$mdDateLocale.days = moment.weekdays();
        this.$mdDateLocale.shortDays = moment.weekdaysShort();
    }
}
